
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gEbRK2ISnF5wgtaXHoIAOUg0bMi5A8jeuuUedS_45T_45GVcMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexNQkDKfBTyASDgTJsybbcxg1BpWqwsOQgR4vT9Ry8C8wMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchD0669AS0pd8wQ_APavs_45bzL6yHGdVzS5NPHdpYe0MiAMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbpGbpchnKGapq8k6va_EJg25kvtfji0CQOWVLS5mt6MMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93TDT4cm125JV2MdN6WeAQpyVQNlmWs2EGM0uL6n_eq8sMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7DGyWujfLopuBAaqsYm8FgBphyEvCX4IZCZW6XOVePEMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93hfJll46xcWH45Mbvd5fNlbDUry1k5FGXkCErIQEGK70Meta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index97w_YkpWkSdbtSm8ADs0ruF9S6yvVRtQBh5OndoDOxoMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_935thZlZ0bc3ys_45swV3cmPDm3MrWMonj6gRIHAq1MqIbwMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvVAhNFBPzRCFn58PNABlvVLF3T1mz8we8To4HmOW97UMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexM2XSttgxM8WiPIRd5Vg3JDbEQjwIj_Jb8WfT4lbxNhIMeta } from "/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7DGyWujfLopuBAaqsYm8FgBphyEvCX4IZCZW6XOVePEMeta || {},
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index97w_YkpWkSdbtSm8ADs0ruF9S6yvVRtQBh5OndoDOxoMeta || {},
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvVAhNFBPzRCFn58PNABlvVLF3T1mz8we8To4HmOW97UMeta || {},
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexM2XSttgxM8WiPIRd5Vg3JDbEQjwIj_Jb8WfT4lbxNhIMeta || {},
    component: () => import("/codebuild/output/src2896174967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]